import {
  ACT_APP_STARTING,
  ACT_APP_STARTED,
} from '../constants/actions';

export const appStartingAction = () => ({
  type: ACT_APP_STARTING,
});

export const appStartedAction = () => ({
  type: ACT_APP_STARTED,
});
